import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import {
  modalBackdropStyles, modalBackgroundStyles, modalBodyStyles, modalContentStyles, modalDialogStyles, modalFooterStyles,
  modalHeaderStyles, modalHeadingStyles
} from "./styles/ConfirmModal.css";
import Button from "./Button";
import {ButtonTypes} from "../../constants/Enums";

class ConfirmModal extends Component {
    constructor(props){
        super(props);

        this.state = {

        };
    }

    render(){
      let {heading, content} = this.props;
      let cancelButton;
        this.props.cancelButtonText==null?cancelButton=null:cancelButton=<Button text={this.props.cancelButtonText} disabled = {this.props.cancelButtonText==null} type={ButtonTypes.SECONDARY} action={this.props.cancel} additionalStyles={{border: 'none'}}/>
        if(this.props.isOpen) {
          return(
            <div className={"modal fade show"} style={modalBackgroundStyles}>
              <div className={"modal-backdrop fade show"} style={modalBackdropStyles}></div>
              <div className={"modal-dialog"} style={modalDialogStyles}>
                <div className={"modal-content"} style={modalContentStyles}>
                  <div className={"modal-header"} style={modalHeaderStyles}>
                    <h4 className={"modal-title"} style={modalHeadingStyles}>{heading}</h4>
                  </div>
                  <div className={"modal-body"} style={modalBodyStyles}>
                    {content}
                  </div>
                  <div className={"modal-footer"} style={modalFooterStyles}>
                    {cancelButton}
                    <Button text={this.props.confirmButtonText} classNames={["ml-3"]} action={this.props.confirm}/>
                  </div>
                </div>
              </div>
            </div>
          );
        }
        else return null;
    }
}

ConfirmModal.propTypes = {
  heading: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  cancel: PropTypes.func,
  confirm: PropTypes.func.isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string
};

export default ConfirmModal;
